const recaptcha = {
  develop: '6Lej-CcdAAAAAEigVoP1O90eEW-1s1iqpCLotr8G',
  production: '6Lc9iCgdAAAAAIdhEeFiaeKYgLTKm7hRMWwJPFSN',
};

export default recaptcha;
